"use client"
import React from "react"
import { useReactFlow } from "reactflow"
import "./NodeControls.css"

const NodeControls = ({ id }) => {
  const { setNodes, getNode } = useReactFlow()

  const handleDelete = () => {
    setNodes((nodes) => nodes.filter((node) => node.id !== id))
  }

  const handleDuplicate = () => {
    const node = getNode(id)
    if (!node) return

    const newNode = {
      ...node,
      id: `${node.type}-${Date.now()}`,
      position: {
        x: node.position.x + 50,
        y: node.position.y + 50,
      },
    }

    setNodes((nodes) => [...nodes, newNode])
  }

  return (
    <div className="node-controls">
      <button className="node-control-button" onClick={handleDuplicate} title="Duplicate">
        <span>⎘</span>
      </button>
      <button className="node-control-button" onClick={handleDelete} title="Delete">
        <span>×</span>
      </button>
    </div>
  )
}

export default NodeControls
